var hasClass = function (el, cl) {
  return (' ' + el.className + ' ').indexOf(' ' + cl + ' ') > -1
}

var getWidthOfClass = function (className) {
  var width = getClassStyle(className).width
  if (width) {
    return parseStyleString(width)
  }
}

var getTransitionDurationOfClass = function (className) {
  var transition = getClassStyle(className).transitionDuration
  if (transition) {
    return parseFloat(transition.substring(0, transition.length - 1))
  }
}

var parseStyleString = function (styleString) {
  var valueSubstring = ''
  var unitSubstring = ''
  for (var i in styleString) {
    if (!isNaN(styleString[i]) || styleString[i] === '.') {
      valueSubstring += styleString[i]
    } else {
      unitSubstring += styleString[i]
    }
  }
  return {
    value: parseFloat(valueSubstring),
    unit: unitSubstring
  }
}

var getClassStyle = function (className) {
  var styleSheets = window.document.styleSheets
  var styleSheetsLength = styleSheets.length
  for (var i = 0; i < styleSheetsLength; i++) {
    var classes = styleSheets[i].rules || styleSheets[i].cssRules
    if (!classes) {
      continue
    }
    var classesLength = classes.length
    for (var x = 0; x < classesLength; x++) {
      if (classes[x].selectorText === className) {
        if (classes[x].style) {
          return classes[x].style
        }
      }
    }
  }
}

var detectSwipe = function (el, func) {
  var swipe_det = {
    sX: 0,
    sY: 0,
    eX: 0,
    eY: 0
  }
  var min_x = 100  //min x swipe for horizontal swipe
  var max_x = 30  //max x difference for vertical swipe
  var min_y = 50  //min y swipe for vertical swipe
  var max_y = 60  //max y difference for horizontal swipe
  var direction = ""

  el.addEventListener('touchstart', function (e) {
    var t = e.touches[0]
    swipe_det.sX = t.screenX
    swipe_det.sY = t.screenY
  }, false)

  el.addEventListener('touchmove', function (e) {
    var t = e.touches[0]
    swipe_det.eX = t.screenX
    swipe_det.eY = t.screenY
  }, false)

  el.addEventListener('touchend', function (e) {
    if ((((swipe_det.eX - min_x > swipe_det.sX) ||
      (swipe_det.eX + min_x < swipe_det.sX)) && ((swipe_det.eY < swipe_det.sY + max_y) &&
      (swipe_det.sY > swipe_det.eY - max_y) && (swipe_det.eX > 0)))) { //horizontal detection
      if (swipe_det.eX > swipe_det.sX) {
        direction = "right"
      } else { 
        direction = "left"
      }
    } else if ((((swipe_det.eY - min_y > swipe_det.sY) || (swipe_det.eY + min_y < swipe_det.sY)) &&
      ((swipe_det.eX < swipe_det.sX + max_x) && (swipe_det.sX > swipe_det.eX - max_x) &&
        (swipe_det.eY > 0)))) { //vertical detection
      if (swipe_det.eY > swipe_det.sY) {
        direction = "down"
      } else {
        direction = "up"
      }
    }

    if (direction !== "" && typeof func === 'function') {
      func(el, direction)
    }
  }, false)
}

var displayTime = function (time) {
  time = Math.round(time)
  var hrs = ~~(time / 3600)
  var mins = ~~((time % 3600) / 60)
  var secs = time % 60
  if (isNaN(secs)) {
    secs = 0
  }
  var ret = ''
  ret += '' + hrs + ':' + (mins < 10 ? '0' : '')
  ret += '' + mins + ':' + (secs < 10 ? '0' : '')
  ret += '' + secs
  return ret
}

const utilities = {
  install: function (Vue, options) {
    Vue.prototype.$utilities = {
      hasClass: hasClass,
      getWidthOfClass: getWidthOfClass,
      parseStyleString: parseStyleString,
      getTransitionDurationOfClass: getTransitionDurationOfClass,
      getClassStyle: getClassStyle,
      detectSwipe: detectSwipe,
      displayTime: displayTime
    }
  },
  hasClass: hasClass,
  getWidthOfClass: getWidthOfClass,
  parseStyleString: parseStyleString,
  getTransitionDurationOfClass: getTransitionDurationOfClass,
  getClassStyle: getClassStyle,
  detectSwipe: detectSwipe,
  displayTime: displayTime
}

export default utilities



// WEBPACK FOOTER //
// ./src/utilities.js